var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTables(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 44,
    viewBox: "0 0 58 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7146",
    "data-name": "Groupe 7146",
    transform: "translate(-134 -168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_681",
    "data-name": "Rectangle 681",
    transform: "translate(134 168)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 44,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 56,
    height: 42,
    rx: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_8",
    "data-name": "Union 8",
    d: "M-4204-5650v-9.761h-18.807v-13.6H-4204V-5682h-19v-7a4,4,0,0,1,4-4h50a4,4,0,0,1,4,4v7h-18v8.64h18v13.6h-18V-5650Zm2-2h17v-7.763h-17Zm19-9.763h16v-9.6h-16Zm-19,0h17v-9.6h-17Zm-18.807,0H-4204v-9.6h-16.807Zm18.807-11.6h17V-5682h-17Z",
    transform: "translate(4357 5862)",
    fill: "#717171"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTables);
export default __webpack_public_path__ + "static/media/tables.7bb8278b157dbb1ee2873b9d16b52b77.svg";
export { ForwardRef as ReactComponent };